import { formatDate } from "../../../components/formatDate";

export const filterData = (dataArray, keys) => {
    return dataArray.map(data =>
      keys.reduce((result, key) => {
        if (data.hasOwnProperty(key)) {
          // Check if the key is userID, and if so, change it to id
          if (key === 'customerID') {
            result['id'] = data[key]; // Map userID to id
          }else if (key === 'firstName') {
            result['Fullname'] = `${data[key]} ${data.lastName || ''}`.trim(); // Combine firstName and lastName
          }else if(key === 'isActive'){
            result[key] = data[key]? 'Active' : 'Inactive';
          }else if(key === 'isLead'){
            result[key] = data[key]? 'Lead' : 'NL';
          } else if(key === 'createDate'){
            result[key] = formatDate(data[key]);
          } else {
            result[key] = data[key];  // Copy other keys as they are
          }        
        }
        return result;
      }, {})
    );
  };